
    /**
    * @class Implementation of the cosine interpolation function:
    * i = b+(a-b)*(0.5+0.5*cos(f*PI))
    * @member toxi
    */
    var	CosineInterpolation = function(){};

    CosineInterpolation.interpolate = function(a, b, f) {
        return b + (a - b) * (0.5 + 0.5 * Math.cos(f * Math.PI));
    };

    CosineInterpolation.prototype.interpolate = CosineInterpolation.interpolate;

    module.exports = CosineInterpolation;





//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/math/CosineInterpolation.js
// module id = 4529
// module chunks = 13